import { useEditMarkedQuiz } from '@repo/api/quiz/useEditMarkedQuiz';
import { createContext, use } from 'react';
import { useParams } from 'react-router';

import { useQuizMarkedData } from '@/hooks/quiz';

import type { ManageQuizMarkContextActions, ManageQuizMarkContextStates, ManageQuizMarkProviderProps } from '.';

const ManageQuizMarkContext = createContext<(ManageQuizMarkContextStates & ManageQuizMarkContextActions) | null>(null);

export function ManageQuizMarkProvider(props: ManageQuizMarkProviderProps) {
  const { children } = props;
  const { id, attemptId } = useParams();

  const { markedData, quizMarkedQuery, updateMarkedQuestion, removeMarkedData, getMarkedQuestionData } = useQuizMarkedData(id, attemptId);

  const editQuizMarked = useEditMarkedQuiz();

  return (
    <ManageQuizMarkContext
      value={{
        getMarkedQuestionData,
        updateMarkedQuestion,
        removeMarkedData,
        quizMarkedQuery,
        editQuizMarked,
        markedData,
      }}
    >
      {children}
    </ManageQuizMarkContext>
  );
}

export function useManageQuizMark() {
  const ctx = use(ManageQuizMarkContext);
  if (!ctx) {
    throw new Error('useManageQuizMark must be used within ManageQuizMarkProvider');
  }
  return ctx;
}
